import { Link, useLocation } from "react-router-dom";
import styles from "./Navbar.module.css";
import "../Css/Shared.css";
import { FaExternalLinkAlt } from "react-icons/fa";
import { useEffect, useState } from "react";
import axios from "axios";

function Navbar() {
    const [isShrunk, setIsShrunk] = useState(false);
    const [user, setUser] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const location = useLocation();
    const [width, setWidth] = useState(window.innerWidth);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    useEffect(() => {
        setWidth(window.innerWidth);
        setMenuOpen(false);
    }, [location.pathname]);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.scrollY;
            setIsShrunk(scrollTop > 50);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    useEffect(() => {
        axios.get("https://eclipsebots.com/api/profile", { withCredentials: true })
            .then((res) => setUser(res.data))
            .catch(() => setUser(null));
    }, []);

    const handleLogout = async () => {
        await axios.post("https://eclipsebots.com/logout", {}, { withCredentials: true });
        setUser(null);
        window.location.href = "https://eclipsebots.com";
    };


    return (
        <div className={`${styles.content} ${isShrunk ? styles.shrink : ""}`}>
            <div className={`${styles.navbar} ${isShrunk ? styles.shrink : ""}`}>
                <div className={styles.left}>
                    <Link to={"/"} className={styles.topic}>
                        <div className={styles.name}>EclipSe Bots</div>
                    </Link>
                    <div className={`${styles.hamburger} ${menuOpen
                        ? styles.navbarOpen
                        : ""}`} onClick={toggleMenu}>
                        <div />
                        <div />
                        <div />
                    </div>
                </div>
                {(location.pathname.startsWith("/dashboard") && width > 991) ? null : (

                    <div className={`${styles.center} ${menuOpen ? styles.navbarOpen : ""}`}>
                        <Link to={"/"} className={styles.topic}>
                            <div className={styles.page}>Inicio</div>
                        </Link>
                        <Link to={"/planos"} className={styles.topic}>
                            <div className={styles.page}>Planos</div>
                        </Link>
                        <a href={"https://eclipsebots.com/discord"} className={styles.topic}>
                            <div className={styles.page}>Discord <FaExternalLinkAlt /></div>
                        </a>
                        {user ? (
                            <div className={`${styles.userBox} ${styles.appear}`}>
                                <Link to={"/dashboard/"}>
                                    <img
                                        src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.${user.avatar.startsWith("a_") ? "gif" : "png"}`}
                                        alt="avatar"
                                        className={styles.avatar}
                                    />
                                    <span className={styles.username}>{user.username}</span>
                                </Link>
                                <button onClick={handleLogout} className={styles.logout}>Sair</button>
                            </div>
                        ) : (
                            <a
                                href={"https://discord.com/oauth2/authorize?client_id=1368164502360555590&response_type=code&redirect_uri=https%3A%2F%2Feclipsebots.com%2Flogin%2Fdiscord%2Fcallback&scope=identify+guilds.join+email"}
                                className={`${styles.topic} ${styles.appear}`}
                            >
                                <button>Login com Discord</button>
                            </a>
                        )}
                    </div>
                )}
                < div className={styles.right}>
                    {user ? (
                        <div className={styles.userBox}>
                            <Link to={"/dashboard/"}>
                                <img
                                    src={`https://cdn.discordapp.com/avatars/${user.id}/${user.avatar}.${user.avatar.startsWith("a_") ? "gif" : "png"}`}
                                    alt="avatar"
                                    className={styles.avatar}
                                />
                                <span className={styles.username}>{user.username}</span>
                            </Link>
                            <button onClick={handleLogout} className={styles.logout}>Sair</button>
                        </div>
                    ) : (
                        <a
                            href={"https://discord.com/oauth2/authorize?client_id=1368164502360555590&response_type=code&redirect_uri=https%3A%2F%2Feclipsebots.com%2Flogin%2Fdiscord%2Fcallback&scope=identify+guilds.join+email"}
                            className={styles.topic}
                        >
                            <button>Login com Discord</button>
                        </a>
                    )}
                </div>
            </div>
        </div >
    );
}

export default Navbar;